const locationNp = {
  selector: {
    districtLabel: 'जिल्ला',
    upazillaLabel: 'उपजिल्ला',
    bazarLabel: 'बजार',
    districtSearchPlaceholder: 'जिल्ला खोज्नुहोस्...',
    upazillaSearchPlaceholder: 'उपजिल्ला खोज्नुहोस्...',
    bazarSearchPlaceholder: 'बजार खोज्नुहोस्...'
  },
  popup: {
    title: 'तपाईंको स्थान छान्नुहोस्',
    instruction: 'डेलिभरी र सामग्रीको उपलब्धता सुधार्न कृपया आफ्नो जिल्ला, उपजिल्ला र बजार छान्नुहोस्।',
    chooseDistrict: 'जिल्ला छान्नुहोस्',
    chooseUpazilla: 'उपजिल्ला छान्नुहोस्',
    chooseBazar: 'बजार छान्नुहोस्',
    districtSearchPlaceholder: 'जिल्ला खोज्नुहोस्...',
    upazillaSearchPlaceholder: 'उपजिल्ला खोज्नुहोस्...',
    bazarSearchPlaceholder: 'बजार खोज्नुहोस्...',
    selectedPrefix: 'छानिएको:',
    confirm: 'निश्चित गर्नुहोस्'
  }
};

export default locationNp;


